import { useMe } from '@/hooks/use-me'
import { useCloseIssue, useVerifyQa } from '@/lib/mutations'
import { isLiveStage, isReleasedStage } from '@/lib/stage'
import type { WorkIssue } from '@/types/github'

/** Shared verify gating + actions so the Sheet, the queue row and the context
 *  menu offer the same affordances. Verifier-only; the bot is the real authority. */
export function useVerifyAffordances(issue: WorkIssue) {
  const isVerifier = useMe()?.isVerifier ?? false
  const verifyQa = useVerifyQa()
  const close = useCloseIssue()

  const reachedQa =
    isReleasedStage(issue.stage) || issue.releasedToQaAt !== null || issue.releasedToProdAt !== null
  const isLive =
    isLiveStage(issue.stage) || issue.releasedToProdAt !== null || issue.releasedAt !== null

  const canVerifyQa =
    isVerifier && issue.state === 'OPEN' && reachedQa && !issue.labels.includes('system/verified-qa')
  const canVerifyProd =
    isVerifier && issue.state === 'OPEN' && isLive && !issue.labels.includes('system/verified')

  return { isVerifier, canVerifyQa, canVerifyProd, verifyQa, close }
}
